'use client';
import React, { createContext, useState, useContext, PropsWithChildren } from 'react';
import { AppLogContext } from '~/services/app-interface';

// 앱 컨텍스트의 타입 정의
type AppContext = {
  appLogContext?: AppLogContext;
  setAppLogContext?: (logContext?: AppLogContext) => void;
  viewedProductIds: string[];
  setViewedProductIds?: (viewProductIds: string[]) => void;
};

// 초기 컨텍스트 값을 생성
const initialAppContext: AppContext = {
  viewedProductIds: [],
};

// 앱 컨텍스트 생성
const AppContext = createContext<AppContext>(initialAppContext);

type AppProviderProps = {
  logContext?: AppLogContext;
};
export const AppProvider = ({ children, logContext }: PropsWithChildren<AppProviderProps>) => {
  const [appLogContext, setAppLogContext] = useState<AppLogContext | undefined>(logContext);
  const [viewedProductIds, setViewedProductIds] = useState<string[]>([]);

  return (
    <AppContext.Provider
      value={{
        appLogContext,
        setAppLogContext,
        viewedProductIds,
        setViewedProductIds,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

// 앱 컨텍스트를 사용하는 훅
export const useAppContext = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useAppContext must be used within a AppProvider');
  }
  return context;
};
